// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__Oenzz","text":"SelectPayment_text__3S0sf","title":"SelectPayment_title__1CtgR","btn":"SelectPayment_btn__za3M_"};